import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "../components/ui/button";
import { signOut } from "../auth/session";
import { CALLER_QUERY_KEY, useCaller } from "../auth/useCaller";

export function NoAccessPage() {
  const { t } = useTranslation();
  const { caller } = useCaller();
  const qc = useQueryClient();

  return (
    <section className="max-w-xl mx-auto text-center space-y-4 py-12">
      <h2 className="text-3xl font-bold">{t("noAccess.title")}</h2>
      <p className="text-muted-foreground">{t("noAccess.message")}</p>
      {caller?.email && (
        <p className="text-sm text-muted-foreground">
          {t("noAccess.signedInAs", { email: caller.email })}
        </p>
      )}
      <Button
        variant="outline"
        onClick={async () => {
          await signOut();
          await qc.invalidateQueries({ queryKey: CALLER_QUERY_KEY });
        }}
      >
        {t("auth.signOut")}
      </Button>
    </section>
  );
}
